import React from 'react';
import { TabContentProps } from '../tabs-types';
import styles from '../tabs.module.scss';

export const TabContent = ({ tabLabel, tabContent }: TabContentProps): React.ReactElement => {
  return (
    <div role="tabpanel" key={`tab-${tabLabel}`} id="tab-content-panel" className={styles.tabpanel}>
      {tabContent}
    </div>
  );
};
